// extracted by mini-css-extract-plugin
module.exports = {"PlayerTag":"LifePoints_PlayerTag__1xypZ","LifePointsContainer":"LifePoints_LifePointsContainer__3rQB_","LifePointsInput":"LifePoints_LifePointsInput__OQQQd"};